import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export const fetchSalesCreditNoteRegister = async (query) => {
  const { data } = await apiClient.get(`/document-registers/sales-credit-notes/${query.queryKey[1]}`);
  return data;
};

const normalizeAttachment = (attachment = {}) => ({
  id: attachment.id ?? null,
  file_name: attachment.file_name ?? attachment.fileName ?? '',
  file_type: attachment.file_type ?? attachment.fileType ?? 'application/octet-stream',
});

const normalizeRegister = (register = {}) => ({
  ...register,
  attachments: Array.isArray(register.attachments) ? register.attachments.map(normalizeAttachment) : [],
});

export const useGetSalesCreditNoteRegisterHandler = (id) => {
  const dispatch = useDispatch();
  const { salesInvoiceRegister } = useTranslatedMessages();
  const messages = salesInvoiceRegister?.handlers || {};
  const [register, setRegister] = useState(undefined);

  const {
    data: fetchedData,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['sales-credit-note-register', id],
    queryFn: fetchSalesCreditNoteRegister,
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
    refetchOnMount: 'always',
    retry: 3,
    enabled: Boolean(id),
  });

  useEffect(() => {
    if (fetchedData) {
      setRegister(normalizeRegister(fetchedData));
    }
  }, [fetchedData]);

  useEffect(() => {
    if (isError) {
      const fallbackMessage = messages.load_one_credit_note_error ?? 'Failed to load credit note register entry';
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message ?? error.message ?? fallbackMessage,
            severity: 'error',
          }),
        );
      } else {
        dispatch(showSnackbar({ message: error?.message ?? fallbackMessage, severity: 'error' }));
      }
    }
  }, [dispatch, error, isError, messages.load_one_credit_note_error]);

  return {
    register,
    isLoading,
  };
};
